import { computePosition, shift, offset, arrow, hide } from '@floating-ui/dom'

import { getEventPath } from './helpers'
import Revealer, { withClose, withA11y, withClassnames } from './reveal'


class Popover extends withClose(withA11y(withClassnames(Revealer))) {

	init() {
		this.element.hidden = true

		super.init()

		this.element.setAttribute('role', 'region')

		this.arrowElement = this.element.querySelector('[data-arrow]')

		// if there is no arrowElement create one and append it to the popover
		if (!this.arrowElement) {
			this.arrowElement = document.createElement('div')
			this.arrowElement.setAttribute('data-arrow', '')
			this.arrowElement.classList.add('popover-arrow')

			this.element.appendChild(this.arrowElement)
		}

		this.currentTrigger = this.trigger[0]

		window.addEventListener('resize', this.updatePosition.bind(this))
	}

	beforeShow() {
		super.beforeShow()
		this.updatePosition()
	}

	handleClick(event) {
		const path = getEventPath(event)
		const currentTrigger = this.trigger.find(trigger => path.includes(trigger))

		if (currentTrigger) {
			this.currentTrigger = currentTrigger
		}

		if (!this.hidden && !currentTrigger && !path.includes(this.element)) {
			this.hide()
		}

		super.handleClick(event)
	}

	updatePosition() {
		computePosition(this.currentTrigger, this.element, {
			middleware: [
				shift(),
				hide(),
				offset(6),
				arrow({ element: this.arrowElement, padding: 5 }),
			],
		}).then(({ x, y, placement, middlewareData }) => {
			const { referenceHidden } = middlewareData.hide;

			if (referenceHidden) {
				this.hide()
				return
			}

			Object.assign(this.element.style, {
				left: `${x}px`,
				top: `${y}px`,
			});

			const staticSide = {
				top: 'bottom',
				right: 'left',
				bottom: 'top',
				left: 'right',
			}[placement.split('-')[0]]

			const { x: arrowX, y: arrowY } = middlewareData.arrow
			const halfArrowWidth = this.arrowElement.offsetWidth / 2

			Object.assign(this.arrowElement.style, {
				left: arrowX != null ? `${arrowX}px` : '',
				top: arrowY != null ? `${arrowY}px` : '',
				right: '',
				bottom: '',
				[staticSide]: -halfArrowWidth + 'px',
			})

		})
	}
}

// This allows the Popover component to be initialized via HTML by setting
// the `data-popover` attribute on the element and the `aria-controls`
// attribute with the id of the popover on the relevant trigger(s)
export function PopoverGlobal() {
	const elements = document.querySelectorAll('[data-popover]')
	const popovers = []

	Array.from(elements).forEach(element => {
		const data = element.dataset.popover
		const settings = data ? JSON.parse(data) : {}

		if (element.id) {
			const popover = new Popover(element, {
				trigger: `[aria-controls="${element.id}"]`,
				await: 'transitionend',
				...settings,
			})

			popovers.push(popover)
		}
	})

	return popovers
}

export default Popover
